// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import translate from "@insite/client-framework/Translate";
import Clock from "@insite/mobius/Icons/Clock";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { iconLinkCommonStyles } from "@stanion/XDL/Utilities/links";
import * as React from "react";
import { css } from "styled-components";

type LocationContentLinkProps = LinkPresentationProps & {
    location: LocationModel & { properties?: any };
    onOpenLocationContent: (location: LocationModel) => void;
};

// XNG-Changes
export interface LocationContentLinkStyles {
    linkStyles: LinkPresentationProps;
}

export const findLocationModalStyles: LocationContentLinkStyles = {
    linkStyles: {
        ...iconLinkCommonStyles(Clock, {
            size: 14,
            css: css`
                flex-shrink: 0;
            `,
        }),
        typographyProps: {
            size: 14,
            weight: 600,
            css: css`
                width: 45px;
                line-height: 20px;
            `,
        },
    },
}

const LocationContentLink: React.FC<LocationContentLinkProps> = ({
    location,
    onOpenLocationContent,
    ...otherProps
}) => {
    // XNG-Changes
    const styles = findLocationModalStyles;
    if (!location?.properties?.hours) {
        return null;
    }
    const handleContentClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onOpenLocationContent(location);
    };
    return (
        <Link onClick={handleContentClicked} {...styles.linkStyles}{...otherProps}>
            {translate("Hours")}
        </Link>
    );
};

export default LocationContentLink;
